<template>
  <v-form class="mt-4 pl-3 pr-3">
    <v-select
      v-for="(kind, idx) in deviceKinds"
      :key="idx"
      :items="deviceOptions[kind].items"
      :label="deviceOptions[kind].label"
      v-model="deviceOptions[kind].current"
      return-object
      @change="switchDevice($event, kind)"
      class="background-dark mb-1"
    >
    </v-select>
  </v-form>
</template>

<script>
export default {
  name: 'LocalSettings',
  data() {
    return {
      deviceOptions: {
        audioinput: {
          label: 'Audio Input',
          items: [],
          current: null,
        },
        audiooutput: {
          label: 'Audio Output',
          items: [],
          current: null,
        },
        videoinput: {
          label: 'Video Input',
          items: [],
          current: null,
        },
      },
    };
  },

  computed: {
    deviceKinds() {
      return Object.keys(this.deviceOptions);
    },
  },

  methods: {
    mediaDevices() {
      return navigator.mediaDevices;
    },

    getUserMedia() {
      // before enumerating devices, get media permssions
      // NOTE: w/o media permissions, safari/ff does not return the labels
      // (like front camera, back camera) for the devices.
      return this.mediaDevices().getUserMedia({ audio: true, video: true });
    },

    getDevicesOfKind(deviceInfos, kind) {
      return deviceInfos.filter(function (deviceInfo) {
        return deviceInfo.kind === kind;
      });
    },

    getDevicesOfKindFormatted(deviceInfos, kind) {
      let devices = this.getDevicesOfKind(deviceInfos, kind);
      return devices.map((device) => {
        return {
          value: device.deviceId,
          text: device.label || 'Device [ id: ',
        };
      });
    },

    compareItemsAndSwitch(option, kind) {
      if (!option.items || !option.items.length) return;

      const current = option.current;
      if (
        !current ||
        !option.items.some(
          (i) => i.value === current.value && i.text === current.text
        )
      ) {
        let device = option.items[0];
        this.deviceOptions[kind].current = device;
        this.switchDevice(device, kind);
      }
    },

    getDeviceSelectionOptions() {
      return this.mediaDevices()
        .enumerateDevices()
        .then((deviceInfos) => {
          this.deviceKinds.forEach((kind) => {
            this.deviceOptions[kind].items = this.getDevicesOfKindFormatted(
              deviceInfos,
              kind
            );
            this.compareItemsAndSwitch(this.deviceOptions[kind], kind);
          });
        });
    },

    switchDevice(device, kind) {
      this.$emit('switchDevice', {
        deviceId: device.value,
        kind,
      });
    },

    onMediaDeviceChange() {
      this.mediaDevices().addEventListener('devicechange', () => {
        this.getDeviceSelectionOptions();
      });
    },

    initMedia() {
      if (!this.mediaDevices()) return false;

      this.getUserMedia()
        .then(() => {
          this.getDeviceSelectionOptions();
          this.onMediaDeviceChange();
        })
        .catch((err) => {
          this.$emit('userMediaError', err);
        });
    },
  },
  created() {
    this.initMedia();
  },
};
</script>
